module.exports = __webpack_public_path__ + "0b4fe4f678a179da8de462ef409d5481.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Auth0Animation/components/Step2/step-2-placeholder.png
// module id = 1565
// module chunks = 0